enum AspectRatios {
  'ONE_BY_ONE' = 100,
  'SIXTEEN_BY_NINE' = 56.25,
  'FOUR_BY_THREE' = 75,
  'FIVE_BY_FOUR' = 125,
  'PORTRAIT' = 1.9,
}

export { AspectRatios }
